import React from 'react'
import ReactDOM from 'react-dom'
import {
    defineCustomElements as defineAudiExclusiveAppManager,
} from '@org-avp/avp-ocs-web-component/loader'

import FeatureApp from './feature-app'
import './systemjs-polyfill'

const REACT_APP_BASE_URL = process.env.REACT_APP_BASE_URL || '/'

    defineAudiExclusiveAppManager(window, {
        resourcesUrl: `${REACT_APP_BASE_URL}ae/`,
    })

import { APP_ROOT_ID } from './constants/appConstants'

// eslint-disable-next-line react/no-deprecated
ReactDOM.render(<FeatureApp />, document.getElementById(APP_ROOT_ID))
